import { Product } from '@bowtie-web/common';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useMemo } from 'react';
import { useAttributeAndQsContext } from '../contexts/AttributeAndQsContext';

const useSortProducts = (products: Product[]) => {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down('xs'));

  const { promoted } = useAttributeAndQsContext();

  const sortedProducts = useMemo(() => {
    if (!isMobileLayout) {
      return products;
    }
    const promotedProducts: Product[] = [];
    const otherProducts: Product[] = [];

    const promotedProductCodes = promoted?.split(',');

    for (const product of products) {
      promotedProductCodes?.includes(product.code)
        ? promotedProducts.push(product)
        : otherProducts.push(product);
    }
    return [...promotedProducts, ...otherProducts];
  }, [isMobileLayout, products, promoted]);

  return sortedProducts;
};

export default useSortProducts;
